module.exports = __webpack_public_path__ + "static/media/fj.ffa1d9ec.svg";